<script setup lang="ts">
  import OnboardingSliderPage from './components/OnboardingSliderPage.vue'
  import OnboardingLottieSlide from './components/OnboardingLottieSlide.vue'
  // Import Lottie animation data
  import overviewAnimation from '@/assets/lottie/my-area-onboarding/overview.json'
  import absencesAnimation from '@/assets/lottie/my-area-onboarding/absences.json'
  import settingsAnimation from '@/assets/lottie/my-area-onboarding/settings.json'
  import { useI18n } from 'vue-i18n'
  import router from '@/router'
  import { useEmployeeStore } from '@/stores/EmployeeStore'
  import { onMounted } from 'vue'

  const { t } = useI18n()

  onMounted(() => {
    useEmployeeStore().flagEmployeeAsOnboarded()
  })
</script>
<template>
  <onboarding-slider-page
    :finish-button-text="t('phrases.new_onboarding.my_area.button.lets_go')"
    @finish="() => router.push({ name: 'myArea' })"
    @skip="() => router.push({ name: 'myArea' })"
  >
    <onboarding-lottie-slide
      :headline="t('phrases.new_onboarding.my_area.heading.my_area')"
      :text="t('phrases.new_onboarding.my_area.text.my_area')"
      :animation-data="overviewAnimation"
    ></onboarding-lottie-slide>
    <onboarding-lottie-slide
      :headline="t('phrases.new_onboarding.my_area.heading.absences')"
      :text="t('phrases.new_onboarding.my_area.text.absences')"
      :animation-data="absencesAnimation"
    ></onboarding-lottie-slide>
    <onboarding-lottie-slide
      :headline="t('phrases.new_onboarding.my_area.heading.settings')"
      :text="t('phrases.new_onboarding.my_area.text.settings')"
      :animation-data="settingsAnimation"
    ></onboarding-lottie-slide>
  </onboarding-slider-page>
</template>
<style scoped></style>
